import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VistaDatosMiEmpresaContainerComponent } from './vista-datos-mi-empresa/components/vista-dato-mi-empresa-container/vista-datos-mi-empresa-container.component';
import { VistaMisEmpresasContainerComponent } from './vista-mis-empresas/components/vista-mis-empresas-container/vista-mis-empresas-container.component';
import { VistaRegistroEmpresaContainerComponent } from './vista-registro-empresa/components/vista-registro-empresa-container/vista-registro-empresa-container.component';
import { EmpresaGuardService } from '../guards/empresa-guard.service';
import { VistaMisIntegrantesComponent } from './vista-mis-integrantes/components/vista-mis-integrantes/vista-mis-integrantes.component';
import { VistaMisIntegrantesContainerComponent } from './vista-mis-integrantes/components/vista-mis-integrantes-container/vista-mis-integrantes-container.component';
import { VistaMisDepositosDependenciasContainerComponent } from './vista-depositos-dependencias/components/vista-mis-depositos-dependencias-container/vista-mis-depositos-dependencias-container.component';

const routes: Routes = [
  {
    path: 'mi-empresa',
    canActivate: [EmpresaGuardService],
    component: VistaDatosMiEmpresaContainerComponent,
    data: { title: 'rpe.route.vista-muestreador' }
  },
  {
    path: 'mis-empresas',
    component: VistaMisEmpresasContainerComponent,
    data: { title: 'rpe.route.vista-muestreador' }
  },
  {
    path: 'registro-empresa',
    component: VistaRegistroEmpresaContainerComponent,
    data: { title: 'rpe.route.vista-muestreador' }
  },
  {
    path: 'mis-integrantes',
    component: VistaMisIntegrantesContainerComponent,
    data: { title: 'rpe.route.vista-muestreador' }
  },
  {
    path: 'mis-actividades',
    component: VistaMisDepositosDependenciasContainerComponent,
    data: { title: 'rpe.route.vista-muestreador' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmpresasRoutingModule { }
